import { Badge } from '@chakra-ui/react'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import type { FlexGroupType } from 'BrokerTsLib/src/enums'
import { useGetFlexGroupType } from 'BrokerTsLib/src/hooks/useFlexGroup'

export const FlexGroupTypeBadge = (props: { type?: FlexGroupType }) => {
  const type = useGetFlexGroupType(props.type)

  return type && <CustomTooltip label={type?.description} hasArrow boxProps={{ justifySelf: 'left' }}>
    <Badge colorScheme="blue">{type?.name}</Badge>
  </CustomTooltip>
}